import styled from 'styled-components'
import TextControl from '@/components/controls/TextControl'
import Button from '@/components/blocks/Button'

export const CustomTextControl = styled(TextControl)`
  width: 217px;
  margin-right: 10px;
  @media (max-width: 910px) {
    width: 100%;
  }

`

export const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  @media (max-width: 910px) {
    width: 100%;
    background-color: #FAFBFB;
    padding: 10px;
  }
`

export const CustomButton = styled(Button)`
  padding: 7px;
  color: ${({ theme }) => theme.colors.colors.light};
  background: ${({ theme }) => theme.colors.scheme.backgrounds.fuelYellow};
`
